<template>
    <div class="row d-flex justify-content-center mt-5">
    
        <div class=" col-4">   
            <b-form @submit.stop.prevent="onSubmit">

                <b-form-group id="email-group" label="Email" label-for="email">
                    <b-form-input id="email" name="email" placeholder="Email" v-model="fdata.email" v-validate="{ required: true, email:true }" :state="validateState('email')" aria-describedby="email-feedback" data-vv-as="Email"></b-form-input>
                    <b-form-invalid-feedback id="email-feedback">{{ veeErrors.first('email') }}</b-form-invalid-feedback>
                </b-form-group>



                <b-form-group id="form_file-group" label="Sample File" label-for="form_file">
                   <b-form-file id="form_file" v-model="form_file" ></b-form-file>                                                    
                </b-form-group>

                

                <b-form-group id="password-group" label="Password" label-for="password">
                    <b-form-input id="password" name="password" placeholder="Password" type="password" v-model="fdata.password" v-validate="{ required: true, min: 8 }" :state="validateState('password')" aria-describedby="password-feedback" data-vv-as="Password"></b-form-input>
                    <b-form-invalid-feedback id="password-feedback">{{ veeErrors.first('password') }}</b-form-invalid-feedback>
                </b-form-group>


                <b-form-group id="login-submit-group">
                    <b-button type="submit" variant="primary">Login</b-button>
                     
                </b-form-group>
            </b-form>
        </div>
    </div>
</template>

<script>
    
    import { Encrypter } from 'laravel-crypton';
    const key = 'OY5c7fhSwaW+5MseQMBoPbEpGYoy4m+y4mIt8JoG+vA=';
    
    const crypt = new Encrypter(key);

    export default{

        
        mounted() {
            //console.log('Bank info started..');   
            //console.log(this.employee_id);  
        },
        props: [],
        data(){            
            
            return {
                
                successmsg:'',
                errormsg:[],
                fdata: {email: null, password:null },

                form_file : null,

                received_data : null,
                
            }
        },
        methods:{
            
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            resetvalidator()
            {
                 this.$validator.reset();
            },
            validateEmail(email) 
            {
                var re = /\S+@\S+\.\S+/;
                return re.test(email);
            },
            resetForm()
            {
                this.fdata = {
                    
                    //asd:null,
                };

                this.$nextTick(() => {
                    this.$validator.reset();
                });
            },            
            onSubmit(e) 
            {
                if(!this.checkNet()) return false;

                

                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }

                    e.preventDefault();  
                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    } 

                    let formData = new FormData();

                    if(this.form_file)
                        formData.append('form_file', this.form_file);
                    
                    for (let [key, value] of Object.entries(this.fdata)) 
                    {                    
                        var nm = `${key}`;
                        var fval = `${value}`;

                        
                        formData.append(nm, crypt.encrypt(fval));  
                        
                        //console.log(crypt.encrypt(fval));
                        //console.log(`${key}: ${value}`);
                    } 

                    axios.post(this.$api_url+'/encrypt', formData, config)
                            .then(function (response) 
                            {
                                                                  
                                console.log(crypt.decrypt(response.data));
                                
                            }.bind(this))
                            .catch(function (error) 
                            { 
                                //console.log(error);                                   
                                //currentObj.showoverlay = false;
                                //currentObj.serverError(error);

                            });

                });
               
            },
            
            
            

        },
        created: function(){
            
            
        },
        computed: 
        {
            
        }
    }
</script>